import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import AudienceSegmentationContextProviderQuery, {
	type AudienceSegmentationContextProviderQuery$data,
	type AudienceSegmentationContextProviderQuery$variables,
} from './__generated__/AudienceSegmentationContextProviderQuery.graphql.ts';

export function preloadAudienceSegmentationContext({ accountId }: { accountId: string }): Promise<{
	data: AudienceSegmentationContextProviderQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<
		AudienceSegmentationContextProviderQuery$data,
		AudienceSegmentationContextProviderQuery$variables
	>({
		query: AudienceSegmentationContextProviderQuery,
		variables: {
			accountId,
		},
	});
}
